export default {
  init() {
    // JavaScript to be fired on single product pages
  },
  finalize() {
    // JavaScript to be fired on single product pages, after the init JS

    // if ($('.related.products ul.products').length) {
    //   $('.related.products ul.products').slick({
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots: false,
    //     responsive: [
    //       {
    //         breakpoint: 1439,
    //         settings: {
    //           slidesToShow: 3,
    //           slidesToScroll: 1,
    //         },
    //       },
    //       {
    //         breakpoint: 1199,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 1,
    //         },
    //       },
    //       {
    //         breakpoint: 575,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1,
    //         },
    //       },
    //     ],
    //   });
    // }

    // if ($('.upsells.products ul.products').length) {
    //   $('.upsells.products ul.products').slick({
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots: false,
    //     responsive: [
    //       {
    //         breakpoint: 1439,
    //         settings: {
    //           slidesToShow: 3,
    //           slidesToScroll: 1,
    //         },
    //       },
    //       {
    //         breakpoint: 1199,
    //         settings: {
    //           slidesToShow: 2,
    //           slidesToScroll: 1,
    //         },
    //       },
    //       {
    //         breakpoint: 575,
    //         settings: {
    //           slidesToShow: 1,
    //           slidesToScroll: 1,
    //         },
    //       },
    //     ],
    //   });
    // }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js